import { render, staticRenderFns } from "./agencies-register.component.vue?vue&type=template&id=573aa79c&"
import script from "./agencies-register.component?vue&type=script&lang=ts&"
export * from "./agencies-register.component?vue&type=script&lang=ts&"
import style0 from "./agencies-register.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports